"use client";
import type { FooterProps } from "@components/layouts/footer/Footer";
import { Layout } from "@components/layouts/Layout";
import type { IUSPBannerProps } from "@components/ui/USPbanner/USPbanner";
import { activeSiteConfig } from "@config/site/site-config";
import type { ContainerProps } from "@ui/components/layout/container/Container";
import dynamic from "next/dynamic";
import { useGlobalContent } from "@app/[locale]/GlobalContentProvider";

const BackToTop = dynamic(() => import("@components/ui/backToTop/BackToTop"), { ssr: false });

const BackToTopWrapper = ({ chatButtonPersist }: { chatButtonPersist?: boolean }) => {
    if (
        (process.env.NEXT_PUBLIC_LIVE_CHAT_SOLUTION === "D365" && activeSiteConfig?.liveChat) ||
        activeSiteConfig?.hasRaffle
    ) {
        return null;
    }
    return <BackToTop chatButtonPersist={chatButtonPersist} />;
};

export const DefaultLayout = ({
    children,
    chatButtonPersist,
    backToTopVisible = true,
    containerProps,
    bannerProps,
    footerProps,
}: {
    children: React.ReactNode;
    chatButtonPersist?: boolean;
    backToTopVisible?: boolean;
    containerProps?: ContainerProps;
    bannerProps?: Partial<IUSPBannerProps>;
    footerProps?: Partial<FooterProps>;
}) => {
    const { siteSettings } = useGlobalContent();

    return (
        <Layout
            siteSettings={siteSettings}
            containerProps={containerProps}
            bannerProps={bannerProps}
            footerProps={footerProps}
        >
            {children}
            {backToTopVisible && <BackToTopWrapper chatButtonPersist={chatButtonPersist} />}
        </Layout>
    );
};
